import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../../../components/Button';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import TelegramWebApiService from '../../../../services/TelegramWebApiService';
import { appSlice } from '../../../../store/slices';
import { createRootModal } from '../../RootModal';
import './DeleteHash.scss';

const DeleteHash = createRootModal(function DeleteHash() {
	const dispatch = useDispatch();

	const closeModal = () =>
		dispatch(
			appSlice.actions.updateModal({
				isOpen: false,
			})
		);

	const LogHashOut = () => {
		TelegramWebApiService.GetCloudStorage().setItem('hash', '');
		RequestService.Logout();
		dispatch(appSlice.actions.setHash(''));
	};

	return (
		<div className='DeleteHash'>
			<div className='DeleteHash-text'>{t('Are you sure you have to re-enter the hash?')}</div>
			<div className='DeleteHash-btns'>
				<Button className='btn-no' onClick={() => closeModal()}>
					{t('No')}
				</Button>
				<Button className='btn-yes' onClick={() => LogHashOut()}>
					{t('Yes, change')}
				</Button>
			</div>
		</div>
	);
});

export default DeleteHash;
